"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = _interopRequireDefault(require("underscore"));

var _FormDropDownList = _interopRequireDefault(require("../../forms/FormDropDownList"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

var MarketSelector = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(MarketSelector, _React$Component);

  var _super = _createSuper(MarketSelector);

  function MarketSelector() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, MarketSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getDDLOption", function (option) {
      return {
        label: option.label,
        value: option.id
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getSelectedOption", function () {
      var _context2;

      var selectedList = (0, _filter.default)(_context2 = _this.props.options).call(_context2, function (option) {
        return option.id === _this.props.market;
      });

      if (selectedList.length > 0) {
        return _this._getDDLOption(selectedList[0]);
      } else {
        return {};
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_getOptions", function () {
      var _context3;

      return (0, _map.default)(_context3 = _this.props.options).call(_context3, _this._getDDLOption);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleMarketChange", function (marketObject) {
      _this.props.onMarketChange(marketObject.value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      return /*#__PURE__*/_react.default.createElement(_FormDropDownList.default, {
        className: "market-selector",
        "data-id": _this.props["data-id"],
        selectedOption: _this._getSelectedOption(),
        onValueChange: _this._handleMarketChange,
        options: _this._getOptions()
      });
    });
    return _this;
  }

  return MarketSelector;
}(_react.default.Component);

(0, _defineProperty2.default)(MarketSelector, "propTypes", {
  "data-id": _propTypes.default.string,
  onMarketChange: _propTypes.default.func,
  market: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    label: _propTypes.default.string
  }))
});
(0, _defineProperty2.default)(MarketSelector, "defaultProps", {
  "data-id": "market-selector",
  onMarketChange: _underscore.default.noop,
  market: "",
  options: []
});
module.exports = MarketSelector;